module.exports = __webpack_public_path__ + "static/media/IELTS-Listening-DragDrop2.959136d5.png";